import { render, staticRenderFns } from "./clockIn_record_details.vue?vue&type=template&id=12282e5e&"
import script from "./clockIn_record_details.vue?vue&type=script&lang=js&"
export * from "./clockIn_record_details.vue?vue&type=script&lang=js&"
import style0 from "./clockIn_record_details.vue?vue&type=style&index=0&id=12282e5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports